import middleware from './middleware';
// Components

const Auth = () => import(/* webpackChunkName: "auth" */ '@auth/Auth');
const Login = () => import(/* webpackChunkName: "auth" */ '@auth/views/Login');
const Logout = () => import(/* webpackChunkName: "auth" */ '@auth/views/Logout');
const Register = () => import(/* webpackChunkName: "auth" */ '@auth/views/Register');
const TenantRegister = () => import(/* webpackChunkName: "auth" */ '@auth/views/TenantRegister');
const FreeTrial = () => import(/* webpackChunkName: "auth" */ '@auth/views/FreeTrial');
const VerifyEmail = () => import(/* webpackChunkName: "auth" */ '@auth/views/VerifyEmail');
const ForgotPassword = () => import(/* webpackChunkName: "auth" */ '@auth/views/ForgotPassword');
const ResetPassword = () => import(/* webpackChunkName: "auth" */ '@auth/views/ResetPassword');
const ConfirmPassword = () => import(/* webpackChunkName: "auth" */ '@auth/views/ConfirmPassword');

const Simple = () => import(/* webpackChunkName: "profile" */ '@layouts/Simple');
const Profile = () => import(/* webpackChunkName: "profile" */ '@auth/views/Profile');

const Play = () => import(/* webpackChunkName: "tenant" */ '@layouts/Play');
const Accounts = () => import(/* webpackChunkName: "tenant" */ '@auth/views/Accounts');
const Start = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/Start');
const GamesList = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/GamesList');
const GamesEdit = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/GamesEdit');
const GameLeaderboard = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/GameLeaderboard');
const Activities = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/Activities');
const ActivitiesHubspot = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/ActivitiesHubspot');
const MissionsList = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/MissionsList');
const MissionsLeaderboard = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/MissionsLeaderboard');
const GoalsList = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/GoalsList');
const GoalsLeaderboard = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/GoalsLeaderboard');
const Achievements = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/Achievements');
const Victories = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/Victories');
const RewardsShop = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/RewardsShop');
const Claims = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/Claims');
const Reports = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/Reports');
const SocialFeed = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/SocialFeed');
const TipsEdit = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/TipsEdit');
const AccountSuspended = () => import(/* webpackChunkName: "tenant" */ '@tenant/views/AccountSuspended');

const AccountSettings = () => import(/* webpackChunkName: "tenantSettings" */ '@tenant/views/AccountSettings');
const SettingsGeneral = () => import(/* webpackChunkName: "tenantSettings" */ '@tenant/views/SettingsGeneral');
const SettingsResidents = () => import(/* webpackChunkName: "tenantSettings" */ '@tenant/views/SettingsResidents');
const SettingsIntegrations = () => import(/* webpackChunkName: "tenantSettings" */ '@tenant/views/SettingsIntegrations');
const SettingsInvitations = () => import(/* webpackChunkName: "tenantSettings" */ '@tenant/views/SettingsInvitations');

const Platform = () => import(/* webpackChunkName: "platform" */ '@components/other/Platform');

const ChangeBrowser = () => import(/* webpackChunkName: "auth" */ '@components/other/ChangeBrowser');
const Error = () => import(/* webpackChunkName: "auth" */ '@components/other/Error');

export default [
	{
		path: "/",
		name: "base",
		redirect: '/user/accounts'
	},
	{
		name: 'tenant.register',
		path: '/register',
		component: Auth,
		beforeEnter: middleware.guest,
		children: [
			{
				path: '',
				component: TenantRegister,
			},
		]
	},
	{
		name: 'tenant.free-trial',
		path: '/free-trial',
		component: Auth,
		beforeEnter: middleware.guest,
		children: [
			{
				path: '',
				component: FreeTrial,
			},
		]
	},
	{
		path: "/user",
		component: Auth,
		redirect: '/user/login',
		children: [
			{
				name: 'login',
				path: 'login',
				component: Login,
				beforeEnter: middleware.guest
			},
			{
				name: 'forgot',
				path: 'forgot-password',
				component: ForgotPassword
			},
			{
				name: 'reset',
				path: 'reset-password/:token?',
				component: ResetPassword,
			},
			{
				name: 'confirm',
				path: 'confirm-password',
				component: ConfirmPassword,
				beforeEnter: middleware.user
			},
			{
				name: 'verificationNotice',
				path: 'verify',
				component: VerifyEmail,
				beforeEnter: middleware.user
			},
			{
				name: 'register',
				path: 'register',
				component: Register,
				beforeEnter: middleware.guest
			},
			{
				name: 'logout',
				path: 'logout',
				component: Logout,
				beforeEnter: middleware.user
			},
			{
				name: 'accounts',
				path: 'accounts',
				component: Accounts,
				beforeEnter: middleware.user
			},
		]
	},
	{
		path: "/user",
		component: Simple,
		children: [
			{
				name: 'profile',
				path: 'profile',
				component: Profile,
				beforeEnter: middleware.user
			}
		]
	},
	{
		name: "platform",
		path: "/platform",
		redirect: '/user/accounts',
		component: Simple,
		children: [
			{
				name: "platformPage",
				path: ':page',
				component: Platform
			},
		]
	},
	{
		name: "tenant",
		path: "/:tenant",
		component: Play,
		beforeEnter: middleware.user,
		redirect: to => ({
			name: "start",
			params: { tenant: to.params.tenant },
		}),
		children: [
			{
				name: 'start',
				path: '',
				component: Start,
				meta: {
					title: "Start",
					icon: "far fa-play",
					showTitle: false,
				}
			},
			{
				name: 'games',
				path: 'games',
				component: GamesList,
				meta: {
					title: "Games",
					icon: "far fa-gamepad-alt",
					showTitle: false,
					gate: [
						'game:viewAny',
						'game:viewOwned',
					]
				}
			},
			{
				name: 'gamesEdit',
				path: 'games/edit/:id?',
				component: GamesEdit,
				meta: {
					title: "Edit Game",
					icon: "far fa-pencil",
					showTitle: false,
					gate: [
						'game:viewAny',
						'game:viewOwned',
					]
				}
			},
			{
				name: 'leaderboard',
				path: 'leaderboard',
				component: GameLeaderboard,
				meta: {
					title: "Leaderboard",
					icon: "far fa-trophy-alt",
					showTitle: true,
					gate: [
						'game:viewLeaderboard'
					]
				}
			},
			{
				name: 'activities',
				path: 'activities',
				component: Activities,
				meta: {
					title: 'Activities',
					icon: "far fa-coins",
					showTitle: true,
					gate: [
						'activity:viewAny',
						'activity:viewOwned'
					]
				}
			},
			{
				name: 'activitiesHubspot',
				path: 'activities/hubspot',
				component: ActivitiesHubspot,
				meta: {
					title: 'Hubspot Activities',
					icon: 'fab fa-hubspot',
					showTitle: true,
				}
			},
			{
				name: 'missions',
				path: 'missions',
				component: MissionsList,
				meta: {
					title: "Mission List",
					icon: "far fa-medal",
					showTitle: true,
					gate: [
						'mission:view'
					]
				}
			},
			{
				name: 'missionsLeaderboard',
				path: 'missions/:id',
				component: MissionsLeaderboard,
				meta: {
					title: "Mission Leaderboard",
					icon: "far fa-trophy-alt",
					showTitle: true,
					gate: [
						'mission:view'
					]
				}
			},
			{
				name: 'goals',
				path: 'goals',
				component: GoalsList,
				meta: {
					title: "Goal List",
					icon: "far fa-medal",
					showTitle: true,
					gate: [
						'goal:view'
					]
				}
			},
			{
				name: 'goalsLeaderboard',
				path: 'goals/:id',
				component: GoalsLeaderboard,
				meta: {
					title: "Goal Leaderboard",
					icon: "far fa-trophy-alt",
					showTitle: true,
					gate: [
						'goal:view'
					]
				}
			},
			{
				name: 'achievements',
				path: 'missions/achievements',
				component: Achievements,
				meta: {
					title: 'Achievements',
					icon: "far fa-award",
					showTitle: true,
					gate: [
						'achievement:viewAny',
						'achievement:viewOwned'
					]
				}
			},
			{
				name: 'victories',
				path: 'goals/victories',
				component: Victories,
				meta: {
					title: 'Victories',
					icon: "far fa-trophy",
					showTitle: true,
					gate: [
						'victory:viewAny',
						'victory:viewOwned'
					]
				}
			},
			{
				name: 'rewards',
				path: 'redeem',
				component: RewardsShop,
				meta: {
					title: "Rewards Shop",
					icon: "far fa-store",
					showTitle: true,
					gate: [
						'reward:view'
					]
				}
			},
			{
				name: 'claims',
				path: 'rewards/claims',
				component: Claims,
				meta: {
					title: "Reward Claims",
					icon: "far fa-list",
					showTitle: true,
					gate: [
						'claim:viewAny',
						'claim:viewOwned'
					]
				}
			},
			{
				name: 'reports',
				path: 'reports',
				component: Reports,
				meta: {
					title: "Reports",
					icon: "far fa-clipboard-list-check",
					showTitle: true,
				}
			},
			{
				name: 'tips',
				path: 'tips',
				component: TipsEdit,
				meta: {
					title: "Outbound TV",
					icon: "far fa-video",
					showTitle: true,
					gate: [
						'tip:update',
						'tip:create',
						'tip:delete'
					]
				}
			},
			{
				name: 'social',
				path: 'social/:id?',
				component: SocialFeed,
				meta: {
					title: "Social Feed",
					icon: "far fa-chart-network",
					showTitle: true,
					gate: [
						'post:view'
					]
				}
			},
			{
				name: 'settings',
				path: 'settings',
				component: AccountSettings,
				meta: {
					title: "Settings",
					icon: "far fa-cog",
					showTitle: true,
					gate: [
						'tenant:settings',
					]
				},
				redirect: to => ({
					name: "settingsGeneral",
					params: { tenant: to.params.tenant },
				}),
				beforeEnter: middleware.user,
				children: [
					{
						name: 'settingsGeneral',
						path: 'general',
						component: SettingsGeneral,
						meta: {
							title: "General Settings",
							icon: "far fa-cog",
							showTitle: true,
							gate: [
								'tenant:settings',
							]
						}
					},
					{
						name: 'settingsResidents',
						path: 'users',
						component: SettingsResidents,
						meta: {
							title: "Active Users",
							icon: "far fa-users",
							showTitle: true,
							gate: [
								'resident:update'
							]
						}
					},
					{
						name: 'settingsInvitations',
						path: 'invitations',
						component: SettingsInvitations,
						meta: {
							title: "Invitations",
							icon: "far fa-user-plus",
							showTitle: true,
							gate: [
								'invitation:create'
							]
						}
					},
					{
						name: 'settingsIntegrations',
						path: 'integrations',
						component: SettingsIntegrations,
						meta: {
							title: "Integrations",
							icon: "far fa-plug",
							showTitle: true,
							gate: [
								'integration:create'
							]
						}
					}
				]
			},
		]
	},
	{
		name: 'tenant.suspended',
		path: '/:tenant/account-suspended',
		component: AccountSuspended,
		meta: {
			title: "Account Suspended",
			showTitle: true,
		}
	},
	{
		name: "changeBrowser",
		path: "/change-browser",
		component: ChangeBrowser
	},
	{
		name: "error",
		path: "/error/:code?",
		component: Error,
		props: (route) => ({ code: parseInt(route.params.code) }),
	}
];
